module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-5-f3208fed3b075f0ceb501bb15c1bb8d4.svg";